export type SiteConfig = typeof siteConfig;

export const siteConfig = {
  name: 'PayStop',
  description: ' ',
  navItems: [
    {
      label: 'Home',
      href: '/',
    },
    {
      label: 'About Us',
      href: '/about-us',
    },
    {
      label: 'Pricing',
      href: '/pricing',
    },

    {
      label: 'Agent Network',
      href: '/agent-network',
    },
    {
      label: 'Contact Us',
      href: '/contact-us',
    },
  ],
  navMenuItems: [
    {
      label: 'Home',
      href: '/',
    },
    {
      label: 'About Us',
      href: '/about-us',
    },
    {
      label: 'Pricing',
      href: '/pricing',
    },

    {
      label: 'Agent Network',
      href: '/agent-network',
    },
    {
      label: 'Contact Us',
      href: '/contact-us',
    },
  ],
  links: {
    github: 'https://github.com/heroui-inc/heroui',
    twitter: 'https://twitter.com/hero_ui',
    docs: 'https://heroui.com',
    discord: 'https://discord.gg/9b6yyZKmH4',
    becomeAnAgent: '/become-agent',
  },
};
